module.exports = __webpack_public_path__ + "static/img/csf.a555e2b8.svg";